package tta.destinigo.talktoastro.feature_profile.purchase_history.data.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_profile.purchase_history.data.api.PurchaseHstoryApi
import tta.destinigo.talktoastro.feature_profile.purchase_history.data.domain.PurchaseHistoryRepo

val PurchaseHistoryModel =  module {
    factory { PurchaseHistoryRepo(get()) }
    factory { PurchaseHstoryApi() }
}